import { useMemo } from 'react';
import useColumns from "./hooks/useColumns";
import ResizableHeaderCell from "./resizableHeaderCell";
var InternalResizableColumn = function InternalResizableColumn(dataFunc, dependencies) {
  var propsData = useMemo(function () {
    var _dataFunc;
    return (_dataFunc = dataFunc === null || dataFunc === void 0 ? void 0 : dataFunc()) !== null && _dataFunc !== void 0 ? _dataFunc : {};
  }, dependencies);
  var _useColumns = useColumns(propsData),
    resizableColumns = _useColumns.resizableColumns,
    tableWidth = _useColumns.tableWidth,
    resetColumns = _useColumns.resetColumns;
  var components = useMemo(function () {
    return {
      header: {
        cell: ResizableHeaderCell
      }
    };
  }, [propsData]);
  return {
    resizableColumns: resizableColumns,
    components: components,
    tableWidth: tableWidth,
    resetColumns: resetColumns
  };
};
export default InternalResizableColumn;